import { Component, OnInit } from '@angular/core';
import { AppConfigurationService, AppSettings } from 'src/app/shared/services/app-configuration.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {
  url: string;
  
  constructor(private appConfigurationService: AppConfigurationService,
    private router: Router) { }

  ngOnInit(): void {
    this.appConfigurationService.settings$
    .pipe(take(1))
    .subscribe((settings: AppSettings) => {
      this.url = this.appConfigurationService.settings.contentDeliveryNetworkUrl;
    });
  }
  goHome(){
    this.router.navigate(['/']);
  }

}
